import { Pipe, PipeTransform, Sanitizer } from '@angular/core';
import { PropertiesSettings } from '../../core/configuration/properties-settings';

@Pipe({
    name: 'euro'
})
export class CurrencyPipe implements PipeTransform {
  constructor(private sanitizer: Sanitizer) {}
  transform(value: number | string): string {
    if (!value) {
      return '0';
    }
    let appoggio: number = +(value.toString());
    if (isNaN(appoggio)) {
      appoggio = +(value.toString().replace(',', '.'));
    }
    if (isNaN(appoggio)) {
      return value.toString();
    }
    value = appoggio;
    let locale = PropertiesSettings.LOCALE_IT;
    value = value ? value : 0;
    let importo = value.toLocaleString(locale, {minimumFractionDigits: 2, maximumFractionDigits: 2});
    return importo;
  }
}
